import { Context, createContext } from 'react';

export interface ProjectData {
    id: string;
}

const ProjectContext: Context<ProjectData> = createContext({ id: '' } as ProjectData);
export default ProjectContext;
